
import { useDispatch, useSelector } from "react-redux"
import styled from "styled-components"
import { useLocation } from "react-router-dom"
import { useEffect, useMemo, useState } from "react"
import { showModal, showNestedModal } from "../../../features/modal/modalSlice"
import { useScrollLock } from "../../../hooks/useScrollLock"
import InputSelect from "../../shared/input/new/InputSelect"
import { RiMore2Line } from "react-icons/ri";
import Btn from "../../shared/button/Btn"
import { addDriverToDailyVehicle, addDriverToRegularDriversList, setRegularDriversAllRegularVehicles } from "../../../features/driversVehicles/driversVehiclesSlice"
import { setDevamliAraclarKayitliArac } from "../../../features/joblist/jobListSlice"
import locationData from "../../../utils/locationData/locationOptions"
import InputSelectPlate from "../../shared/input/special/InputSelectPlate"
import { handleActiveSelect } from "../../../features/layout/layoutSlice"
import InputCityTown from "../../shared/input/new/InputCityTown"
import InputDate from "../../shared/input/new/InputDate"
import { toast } from "react-toastify"
const Container = styled.div`
    position: fixed;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    background-color: rgba(0,0,0,0.6);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 100;

    .modal{
        width: 600px;
        height: auto;
        max-height: 650px;
        overflow: auto;
        padding: 50px;
        color: ${({ theme }) => theme.mainTextColor};
        background-color: ${({ theme }) => theme.mainBgColor};
        padding: 20px;
        border-radius: 10px;

        .content{

            display: flex;
            flex-direction: column;
            padding: 30px;

            h2{
                font-size: 16px;
                font-weight: 700;
                color: ${({theme}) => theme.mainTextColor};
                margin-bottom: 20px;
                border-bottom: 1px solid ${({theme}) => theme.mainTextColor};
            }

            .data-list{
                display: flex;
                flex-direction: column;
                gap: 10px;

                .data-item{
                    display: flex;
                    gap: 10px;
                    font-size: 14px;
                    font-weight: 600;

                    .key{
                        width: 200px;
                    }
                }
            }

            .vehicle-container{
                display: flex;
                flex-direction: column;
                margin-top: 30px;

                h3{
                    font-size: 15px;
                    font-weight: 700;
                    color: ${({theme}) => theme.mainTextColor};
                    margin-bottom: 20px;
                border-bottom: 1px solid ${({theme}) => theme.mainTextColor};

                }

                .vehicle-list{
                    display: flex;
                    flex-direction: column;
                    gap: 10px;

                    .vehicle-item{
                        font-size: 14px;
                        font-weight: 600;
                        color: ${({theme}) => theme.mainTextColor};
                    }

                    .show-all{
                        color: var(--color-main);
                        text-decoration: underline;
                        font-size: 14px;
                        font-weight: 600;
                        width: max-content;
                        cursor: pointer;
                    }

                }
            }

            .adding-container{
                margin-top: 30px;
                display: flex;
                flex-direction: column;

                h3{
                    font-size: 15px;
                    font-weight: 700;
                    color: ${({theme}) => theme.mainTextColor};
                    margin-bottom: 20px;
                    border-bottom: 1px solid ${({theme}) => theme.mainTextColor};

            }

                .input-list{
                    display: flex;
                    flex-direction: column;
                    gap: 20px;

                }



        }
                    .btn-container{
                margin-top: 30px;
                display: flex;
                flex-direction: row !important;
                justify-content: center;
                gap: 20px;
                width: 100%;
            }
    }}

`


const BoolData = [
    {
        id:1,
        text:"Evet",
        bool:true
    },
    {
        id:2,
        text:"Hayır",
        bool:false
    }
]

const aracDurumu = [
    {
        id: 1,
        text: "Boşta Hazır",
    },
    {
        id: 2,
        text: "Yük Boşaltıyor",
    },
    {
        id: 3,
        text: "Yolda",
    },
    {
        id: 4,
        text: "Yarın Boşta",
    },
];

const emptyVehicleSelection = {
    plate: "",
    vehicleType: "",
    vehicleOwnerId: "",
    isReferenceDriver: "",
    truckOrTrailer: ""
}

    //! 531 504 25 56
    //! eskisi DevamliNewUserContent
const AddDailyQueueModal = () => {

    const {modalLocation } = useSelector(state => state.modal)
    const dispatch = useDispatch()
    const location = useLocation()
    const { lockScroll, unlockScroll } = useScrollLock();

    const {jobListDriverData, isLoadingJobListPhoneNumberOrNameQuery} = useSelector(state => state.driversVehicles)

    const [selectedTruckPlate, setSelectedTruckPlate] = useState(emptyVehicleSelection)
    const [selectedTrailerPlate, setSelectedTrailerPlate] = useState(emptyVehicleSelection)

    const [truckStatus, setTruckStatus] = useState(null)
    const [truckLocation, setTruckLocation] = useState(null)

    const [timeToWaste, setTimeToWaste] = useState("")


    const [whichRegion, setWhichRegion] = useState("")

    const [whichCities, setWhichCities] = useState("")

    const vehicles = useMemo(() => {
        const vehicleList = jobListDriverData?.vehicles?.$values ?? jobListDriverData?.vehicles
        return Array.isArray(vehicleList) ? vehicleList : []
    }, [jobListDriverData?.vehicles])
    const truckOptions = useMemo(
        () => vehicles.filter(item => item.truckOrTrailer === 0),
        [vehicles]
    )
    const allTrailerOptions = useMemo(
        () => vehicles.filter(item => item.truckOrTrailer === 1),
        [vehicles]
    )
    const selectedTruckOwnerId = selectedTruckPlate?.vehicleOwnerId
    const selectedTruckSupportsTrailer = selectedTruckPlate?.vehicleType === "Çekici"
    const trailerOptions = useMemo(
        () => selectedTruckSupportsTrailer
            ? selectedTruckOwnerId
                ? allTrailerOptions.filter(item => item.vehicleOwnerId === selectedTruckOwnerId)
                : allTrailerOptions
            : [],
        [allTrailerOptions, selectedTruckOwnerId, selectedTruckSupportsTrailer]
    )

    const handleTruckSelection = (truck) => {
        setSelectedTruckPlate(truck)

        const nextOwnerId = truck?.vehicleOwnerId
        const trailerOwnerId = selectedTrailerPlate?.vehicleOwnerId
        if (
            !truck?.plate ||
            truck?.vehicleType !== "Çekici" ||
            (nextOwnerId && trailerOwnerId && nextOwnerId !== trailerOwnerId)
        ) {
            setSelectedTrailerPlate(emptyVehicleSelection)
        }
    }

    // //! bu modal açıldığnda ekran ı lock lamak için
    useEffect(() => {
    lockScroll()

    return () => {
        unlockScroll()
    }
    }, [lockScroll, unlockScroll])

    // //! bu başka bir sayfaya geçildiğinde modal ı kapatmak için
    useEffect(() => {
        if (location.pathname !== modalLocation) {
            dispatch(showModal(null))
        }
    }, [dispatch, location.pathname, modalLocation])

    // useEffect(() => {
    //     console.log(isSubmit);
        
    //     if(isSubmit){

    //         if(isRef.id && isRegular.id){
    //             setError(false)
    //         }
    //         else{
    //             setError(true)
    //         }
    //     }


    // },[isRef.id, isRegular.id, isSubmit])

    
    const handleSubmit = () => {
        if(truckStatus?.text && selectedTruckPlate?.plate){

            const data = {
                phoneNumber: jobListDriverData?.phoneNumber,
                vehicleStatus: truckStatus?.text,
                vehicleCurrentLocation: truckLocation?.location,
                timeToWaste: timeToWaste ?  new Date(timeToWaste).toISOString() : null,
                truckPlate: selectedTruckPlate?.plate,
                trailerPlate: selectedTruckSupportsTrailer ? selectedTrailerPlate?.plate : ""
            }
            dispatch(addDriverToDailyVehicle(data))

        }
        else{
                toast.error(`Lütfen zorunlu olan Araç Plakası, Araç Durumu alanlarını doldurarak yeniden deneyin.`, {
                    position: "bottom-right",
                    autoClose: 2000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                    theme: "light",
                });
        }
    }


    if(!jobListDriverData){
        return null
    }
  return (
    <Container>
        <div className="modal" onClick={(e)=> {e.stopPropagation(); dispatch(handleActiveSelect(null))}}>
            <div className="content">
                <h2>Sıraya Ekle</h2>

                <div className="data-list">
                    <div className="data-item">
                        <div className="key">Adı Soyadı</div>
                        <div className="value">{jobListDriverData.adSoyadUnvan}</div>
                    </div>
                    <div className="data-item">
                        <div className="key">Telefonu</div>
                        <div className="value">{jobListDriverData.phoneNumber}</div>
                    </div>
                    <div className="data-item">
                        <div className="key">Devamlı Araç Mı?</div>
                        <div className="value">{jobListDriverData.isContinueVehicle ? "Evet" : "Hayır"}</div>
                    </div>
                    <div className="data-item">
                        <div className="key">Referans Mısınız?</div>
                        <div className="value">{jobListDriverData.isReferenceDriver ? "Kendi Aracım" : "İşverenin Aracı"}</div>
                    </div>
                </div>

                <div className="vehicle-container">
                    <h3>Sürücünün Araçları ({vehicles.length})</h3>
                    <div className="vehicle-list">
                    {
                        vehicles.slice(0,5).map(item => (
                                    <div className="vehicle-item">{item.plate} - {item.vehicleType} - {item?.isReferenceDriver === 1 ? "Kendi Aracım" : "İşverenin Aracı"
                                    }
                </div>
                        ))
                    }
                    {
                        vehicles.length > 5 &&
                        <div onClick={()=> { dispatch(showNestedModal("regularVehicleList")); dispatch(setRegularDriversAllRegularVehicles(vehicles)) }} className="show-all">Tümünü Gör</div>
                    }
                    </div>

                </div>

                <div className="adding-container">
                    <h3>Sıraya Kayıt İşlemi</h3>
                    
                    <div className="input-list">
                        <InputSelectPlate data={selectedTruckPlate?.plate ? `${selectedTruckPlate.plate}-${selectedTruckPlate.vehicleType}` : ""} setData={handleTruckSelection} labelText={"Araç Plakası"} inputWidth={"100%"} name={"selectedTruckPlate"} initialOptions={truckOptions}/>

                        {selectedTruckSupportsTrailer &&
                            <InputSelectPlate data={selectedTrailerPlate?.plate ? `${selectedTrailerPlate.plate}-${selectedTrailerPlate.vehicleType}` : ""} setData={setSelectedTrailerPlate} labelText={"Dorse Plakası"} inputWidth={"100%"} name={"selectedTrailerPlate"} initialOptions={trailerOptions}/>
                        }

                        <InputSelect data={truckStatus?.text} setData={setTruckStatus} labelText={"Araç Durumu"} inputWidth={"100%"} name={"truckStatus"} initialOptions={aracDurumu}/>

                        <InputDate data={timeToWaste} setData={(e) => setTimeToWaste(e.target.value)} labelText={"Boşa Çıkma Zamanı"} inputWidth={"100%"} name={"timeToWaste"}/>

                        <InputCityTown data={truckLocation?.location} setData={setTruckLocation} labelText={"Araç Nerede"} inputWidth={"100%"} name={"truckLocation"} initialOptions={locationData}/>
                    </div>
                </div>

            <div className="btn-container">
                <Btn bgColor="var(--color-main)" color="#fff" width={"180px"} handleClick={() => handleSubmit()}>Sıraya Ekle</Btn>
                <Btn bgColor="transparent" color="var(--color-main)" width={"140px"} handleClick={() => dispatch(showModal(null))}>Vazgeç</Btn>
            </div>
            </div>

        </div>
    </Container>
  )
}

export default AddDailyQueueModal
